import Typography from '../../../components/Typography/Typography'
import { Menu } from 'antd'
import { ExpectedSavingsMenuItems } from './constants'
import { TActualMenuProps } from './types'
import useRouter from '../../../hooks/useRouter'
import { routes } from '../../../router'

const ExpectedSavingMenu = ({ setVisible }: TActualMenuProps) => {
  const { navigate } = useRouter()

  const handleClick = (key: string) => {
    !!setVisible && setVisible(false)
    switch (key) {
      case 'edit':
        return navigate(`${routes.savingGoals}`, { replace: true })
      default:
        return
    }
  }
  return (
    <Menu className="menu-items-wrapper actual-savings-menu">
      {ExpectedSavingsMenuItems.map((i) => (
        <Menu.Item key={i.key} onClick={() => handleClick(i.key)}>
          <Typography.Body1>{i.label}</Typography.Body1>
        </Menu.Item>
      ))}
    </Menu>
  )
}

export default ExpectedSavingMenu
